import config from "./config";
var axios = config();

export default {
  getObjectTags(appName, objectName, objectId) {
    var query = "";
    if (appName) {
      query += "&appname=" + appName;
    }
    if (objectName) {
      query += "&objectname=" + objectName;
    }
    if (objectName) {
      query += "&objectId=" + objectId;
    }
    return axios.get("/api/tags?" + query);
  },
  getTag(id) {
    return axios.get("/api/tags/" + id);
  },
  getTags(tag) {
    var query = "";
    if (tag) {
      query += "?search=" + tag;
    }
    return axios.get("/api/tags/all" + query);
  },
  createTags(tags, appName, objectName, objectId) {
    var query =
      "?appname=" +
      appName +
      "&objectname=" +
      objectName +
      "&objectId=" +
      objectId;
    return axios.post("/api/tags/" + query, tags);
  }
};
